export const credentials = [
  {
    id: 'mgia',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/home/mgia_logo.png',
    caption: 'Michigan Green Industry Association',
    href: 'https://www.landscape.org/',
  },
  {
    id: 'hlc',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/Logos%20-%20other/HLC%20ColorLogo132.jpg120x120.jpg',
    caption: 'Healthy Lawn Care Program for Watershed Protection',
    href: 'https://www.landscape.org/healthylawn',
  },
  {
    id: 'icpi',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/Logos%20-%20other/logo_2.png',
    caption: 'ICPI Level I Brick Paver Installer',
    href: 'https://www.daalexander.com/BrickPaversHardscape',
  },
  {
    id: 'sima',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/home/sima_logo.png',
    caption: 'Snow & Ice Management Association',
    href: 'https://www.sima.org/',
  },
  {
    id: 'bia',
    logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/home/mem_logo.png',
    caption: 'Building Industry Association of Southeastern Michigan',
    href: 'https://www.daalexander.com/AboutUs',
  },
];

export const hbaAward = {
  label: 'Former HBA Subcontractor of the Year',
  href: 'https://www.daalexander.com/Awards',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/www.daalexander.com/uploaded/images/Logos%20-%20other/HBA%20Sub%20of%20the%20Year%202015%20logo%20alt.gif200x200.gif',
};

export const testimonial = {
  quote:
    'The landscaping/hardscaping exceeded our expectations. You added beautiful features that will be enjoyed for many years to come.',
  attribution: 'Northville client',
  href: 'https://www.daalexander.com/Testimonials',
};
